import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigureTabComponent } from './configure_tab.comonent';
import { AuthGuard, SharedModule } from '../../../shared';
import { ConfigTabService } from './tab.service';

const configureTabRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/dfb/config/tab',
    component: ConfigureTabComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [  
    SharedModule,
    configureTabRouting,
    NgbModule
  ],
  declarations: [
    ConfigureTabComponent
  ],
  providers: [
 ConfigTabService
  ],
})
export class ConfigureTabModule {}




// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configure_tab/tab.module.ts